<template>
  <router-view />
</template>

<script setup>
import { onUnmounted } from 'vue'
import { useUpdateDetector } from '@/composables/useUpdateDetector'

const { cleanup } = useUpdateDetector()

onUnmounted(cleanup)
</script>
